import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-back-button',
  imports: [IconComponent],
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss'
})
export class BackButtonComponent {
  private readonly location: Location = inject(Location);

  public onClick(): void {
    this.location.back();
  }
}
